module.exports = __webpack_public_path__ + "static/media/passive-income.284299be.png";